import {z} from 'zod';

// DataMode is used to scope data between live mode and test mode
export const DataModeSchema = z.enum(['live', 'test']);
export type DataMode = z.infer<typeof DataModeSchema>;
